export default {
  label: 'Pobieraj opłatę serwisową od zamówień przy stolikach',
  description: 'Zamówienia przy stolikach nie płacą opłaty serwisowej, dopóki ta opcja nie jest włączona.',
  no_fee: 'Twoja restauracja nie pobiera opłaty serwisowej, więc zamówienia przy stolikach również jej nie płacą.',
  partner_default_on: 'Domyślnie u partnera: włączone',
  partner_default_off: 'Domyślnie u partnera: wyłączone',
  toasts: {
    on: 'Zamówienia przy stolikach płacą teraz opłatę serwisową',
    off: 'Zamówienia przy stolikach nie płacą już opłaty serwisowej',
    error: 'Nie zapisano. Spróbuj ponownie.',
  },
};
